import { render, staticRenderFns } from "./form-edit-normal.vue?vue&type=template&id=54c95664&"
import script from "./form-edit-normal.vue?vue&type=script&lang=ts&"
export * from "./form-edit-normal.vue?vue&type=script&lang=ts&"
import style0 from "./form-edit-normal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports